import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { DefaultTheme, useTheme } from 'styled-components';
import { toast } from 'react-toastify';
import { Formik, Form, FormikHelpers } from 'formik';
import { MdSearch } from 'react-icons/md';
import Swal from 'sweetalert2';
import { Breadcrumb } from '../../components/Breadcrumb';
import { Button } from '../../components/Button';
import { ICampaing } from '../../interfaces/ICampaing';
import api from '../../services/api';
import { IPagination, Pagination } from '../../components/Pagination';
import { Filters } from '../../components/Filters';
import { Input } from '../../components/Input';
import { ItemWithThumb } from '../../components/ItemWithThumb';

export const Campaign = () => {
  const location = useLocation();
  const history = useHistory();
  const theme: DefaultTheme = useTheme();
  const [campaigns, setCampaings] = useState<ICampaing[]>([]);
  const [pagination, setPagination] = useState<IPagination>();

  useEffect(() => {
    api
      .get(`/campaigns/${location.search}`)
      .then(({ data }) => {
        setCampaings(data.data);
        setPagination({
          currentPage: data.meta.current_page,
          perPage: data.meta.per_page,
          total: data.meta.total,
        });
      })
      .catch(() => toast.error('Erro ao buscar campanhas'));
  }, [location.search]);

  const handleSubmit = (
    values: { name: string },
    helpers?: FormikHelpers<{ name: string }>,
  ) => {
    const { name } = values;
    if (name === '' || name === ' ') return;
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set('name', name);
    urlSearchParams.delete('page');

    history.push({
      pathname: history.location.pathname,
      search: urlSearchParams.toString(),
    });

    if (helpers) {
      helpers.setFieldValue('name', '');
    }
  };

  const handleRemoveUser = (idCampaign: number) => {
    Swal.fire({
      title: `<h4 style="color: ${theme.colors.textSecondary}">Você tem certeza?</h4>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: theme.colors.secondary,
      cancelButtonColor: theme.colors.textSecondary,
      cancelButtonText: 'Fechar',
      confirmButtonText: 'Sim, apagar!',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          await api.delete(`campaigns/${idCampaign}`);
          setCampaings(old => [...old.filter(item => item.id !== idCampaign)]);
          toast.success('Campanha excluída com sucesso');
        } catch {
          toast.error('Erro ao excluir Campanha');
        }
      }
    });
  };

  return (
    <div>
      <Breadcrumb
        items={[
          {
            title: 'Campanhas',
          },
        ]}
      />
      <Row className="d-flex align-items-center mt-4">
        <Col md={10} xs={9}>
          <h4>Gerenciar campanhas</h4>
        </Col>
        <Col md={2} xs={{ span: 3 }}>
          <Button
            type="button"
            background={theme.colors.secondary}
            color="#fff"
            onClick={() => history.push('/campaigns/new')}
          >
            Novo
          </Button>
        </Col>
      </Row>
      <Formik
        initialValues={{
          name: '',
        }}
        enableReinitialize
        onSubmit={(values, helpers) => handleSubmit(values, helpers)}
      >
        <Form>
          <Row>
            <Col md={10} xs={8}>
              <Input
                type="text"
                name="name"
                icon={MdSearch}
                placeholder="Nome da campanha"
              />
            </Col>
            <Col md={2} xs={4}>
              <Button
                type="submit"
                style={{ marginTop: '1rem' }}
                background={theme.colors.secondary}
                color="#fff"
              >
                Buscar
              </Button>
            </Col>
          </Row>
          <Filters />
        </Form>
      </Formik>

      <Row className="mt-2">
        {campaigns.map(item => (
          <Col md={4} key={item.id}>
            <ItemWithThumb
              name={item.nameCampaign}
              urlImage={item.logo}
              urlRedirect={`/campaigns/${item.id}`}
              id={item.id}
              onRemoveItem={handleRemoveUser}
              onPushReport={() => history.push(`/campaigns/${item.id}/report`)}
            />
          </Col>
        ))}
        <Col md={12}>{pagination && <Pagination {...pagination} />}</Col>
      </Row>
    </div>
  );
};
